import { RecaptchaLibToken } from '../types/types';
import { logger } from '@/services/logger/logger';

/**
 * executeV3()
 */
export default async (v3SiteKey: string, action: string): Promise<RecaptchaLibToken> => {
  // Check if grecaptcha is available and has execute method
  if (!window.grecaptcha?.enterprise?.execute) {
    logger.error('No reCAPTCHA enterprise execute method available');
    return null;
  }

  try {
    const token = await window.grecaptcha.enterprise.execute(v3SiteKey, { action });
    return token;
  } catch (error) {
    return null;
  }
};
